import { render } from "./TakeawayToffeevTineTthree.vue?vue&type=template&id=2f6e6216"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakeawayToffeevTineTthree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f6e6216"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f6e6216', __exports__)) {
    api.reload('2f6e6216', __exports__)
  }
  
  module.hot.accept("./TakeawayToffeevTineTthree.vue?vue&type=template&id=2f6e6216", () => {
    api.rerender('2f6e6216', render)
  })

}


export default __exports__